export const getTableStyle = ({ isMobile, theme }: { isMobile: boolean; theme: any }) => {
	return {
		table: {
			maxWidth: '100%',
		},
	};
};
